module.exports = __webpack_public_path__ + "static/img/sftp2.770f5ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/sftp2.png
// module id = Dxr9
// module chunks = 1